import { combineReducers } from "redux";
import overlayReducer from "./overlayReducer";
import currentUserReducer from "./currentUserReducer";
import themeReducer from "./themeReducer";

const rootReducer = combineReducers({
    overlay: overlayReducer,
    currentUser: currentUserReducer,
    theme: themeReducer,
});
export default rootReducer;